import { IBANS } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const IbansExporter = createExporter(`payment_${IBANS}.xlsx`,
    [
        { key: "ibanNumber", label: "IBAN" },
        { key: "bic", label: "BIC код за плащане в лева" },
        { key: "bicForeign", label: "BIC код за плащане във валута" },
        { key: "swiftCode", label: "SWIFT код" },
        { key: "bankCode", label: "Банков код" },
        { key: "bankName", label: "Име на банка" },
        { key: "recipientNames", label: "Име на получател на български език" },
        { key: "recipientNamesEn", label: "Име на получател на английски език" }
    ],
    (record) => (
    {
        ...record,
    })
);